import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import UserDetails from "./screens/userDetails";
import Directorate from "./screens/directorate";
import Login from "./screens/login";
import Users from "./screens/users";
import Departments from "./screens/departments";
import Uploads from "./screens/upload";
import Courses from "./screens/courses";
import ApproveResults from "./screens/approveResults";
import ForgotPassword from "./screens/forgotPassword";
import ResetPassword from "./screens/resetPassword";
import Profile from "./screens/profile";
import Session from "./screens/session";
import ViewResults from "./screens/viewResults";
import PendingUpload from "./screens/pendingUpload";
import PendingApproval from "./screens/pendingApproval";
import ApprovedResults from "./screens/approvedResults";
import ProtectRoute from "./utils/protectedRoute";
import Students from "./screens/students";
import ViewResultDetails from "./screens/viewResultDetails";
import CummulativeResult from "./screens/cummulativeResults";
import DashboardLayout from "./components/dashboardLayout/main";
import AuthLayout from "./components/newAuthLayout/main";
import Locations from "./screens/locations";
import GenerateStudentScore from "./screens/generateStudentScore";
import PreviewTranscript from "./screens/previewTranscript";
import Requests from "./screens/requests";
import TranscriptSetup from "./screens/transcriptSetup";
import RequestDetails from "./screens/requestDetails";
import AuditTrail from "./screens/auditTrail";
import TranscriptReport from "./screens/transcriptReport";
import TranscriptReportDetails from "./screens/transcriptReportDetails";
import GenerateTranscript from "./screens/generateTranscript";
import AdminUsers from "./screens/adminUsers";
import TranscriptAdminDetails from "./screens/transcriptAdminDetails";
import Certificate from "./screens/certificate";
import PendingCertificate from "./screens/pendingCertificate";
import ProcessedCertificate from "./screens/processedCertificate";
import ViewCurrentResult from "./screens/viewCurrentResult";
import ViewMasterResult from "./screens/viewMasterResult";
import ViewMasterResultExport from "./screens/viewMasterResultExport";
import FinalResultSummary from "./screens/finalResultSummary";

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <AuthLayout>
              <Login />
            </AuthLayout>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectRoute userRoles={["Admin"]}>
              <DashboardLayout>
                <Users />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/userDetails/:userId"
          element={
            <ProtectRoute userRoles={["Admin"]}>
              <DashboardLayout>
                <UserDetails />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/directorates"
          element={
            <ProtectRoute userRoles={["Admin"]}>
              <DashboardLayout>
                <Directorate />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/departments"
          element={
            <ProtectRoute userRoles={["Admin"]}>
              <DashboardLayout>
                <Departments />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/courses"
          element={
            <ProtectRoute userRoles={["Admin"]}>
              <DashboardLayout>
                <Courses />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/students"
          element={
            <ProtectRoute userRoles={["Admin"]}>
              <DashboardLayout>
                <Students />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/session"
          element={
            <ProtectRoute userRoles={["Admin"]}>
              <DashboardLayout>
                <Session />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/upload"
          element={
            <ProtectRoute userRoles={["Admin"]}>
              <DashboardLayout>
                <Uploads />
              </DashboardLayout>
            </ProtectRoute>
          }
        />

        <Route
          path="/location"
          element={
            <ProtectRoute userRoles={["Lecturer"]}>
              <DashboardLayout>
                <Locations />
              </DashboardLayout>
            </ProtectRoute>
          }
        />

        <Route
          path="/approve-results"
          element={
            <ProtectRoute userRoles={["Exam Officer", "Admin"]}>
              <DashboardLayout>
                <ApproveResults />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/viewResults/:courseCode"
          element={
            <ProtectRoute userRoles={["Exam Officer", "Admin"]}>
              <DashboardLayout>
                <ViewResults />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/view-results"
          element={
            <ProtectRoute>
              <DashboardLayout>
                <ViewResultDetails />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/view-current-results"
          element={
            <ProtectRoute>
              <DashboardLayout>
                <ViewCurrentResult />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/view-master-results"
          element={
            <ProtectRoute userRoles={["Exam Officer", "Admin"]}>
              <DashboardLayout>
                <ViewMasterResult />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/view-master-results-export"
          element={
            <ProtectRoute userRoles={["Exam Officer", "Admin"]}>
              <DashboardLayout>
                <ViewMasterResultExport />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/final-result-summary"
          element={
            <ProtectRoute userRoles={["Exam Officer", "Admin"]}>
              <DashboardLayout>
                <FinalResultSummary />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/cumulative-results"
          element={
            <ProtectRoute>
              <DashboardLayout>
                <CummulativeResult />
              </DashboardLayout>
            </ProtectRoute>
          }
        />

        <Route
          path="/forgot-password"
          element={
            <AuthLayout>
              <ForgotPassword />
            </AuthLayout>
          }
        />
        <Route
          path="/reset-password"
          element={
            <ProtectRoute>
              <AuthLayout>
                <ResetPassword />
              </AuthLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectRoute>
              <DashboardLayout>
                <Profile />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/generate-student-score"
          element={
            <ProtectRoute userRoles={["Admin", "Lecturer"]}>
              <DashboardLayout>
                <GenerateStudentScore />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/pending-upload"
          element={
            <ProtectRoute>
              <DashboardLayout>
                <PendingUpload />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/pending-approval"
          element={
            <ProtectRoute>
              <DashboardLayout>
                <PendingApproval />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/approved-results"
          element={
            <ProtectRoute>
              <DashboardLayout>
                <ApprovedResults />
              </DashboardLayout>
            </ProtectRoute>
          }
        />

        <Route
          path="/graduant-list"
          element={
            <ProtectRoute userRoles={["Admin"]}>
              <DashboardLayout>
                <Certificate />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/generate-transcript"
          element={
            <ProtectRoute userRoles={["Admin"]}>
              <DashboardLayout>
                <GenerateTranscript />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/preview-transcript"
          element={
            <ProtectRoute userRoles={["Admin"]}>
              <DashboardLayout>
                <PreviewTranscript />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/requests"
          element={
            <ProtectRoute userRoles={["Admin"]}>
              <DashboardLayout>
                <Requests />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/setup-transcript"
          element={
            <ProtectRoute userRoles={["Admin"]}>
              <DashboardLayout>
                <TranscriptSetup />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/request-details/:id"
          element={
            <ProtectRoute userRoles={["Admin"]}>
              <DashboardLayout>
                <RequestDetails />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/audit-trail"
          element={
            <ProtectRoute userRoles={["Admin"]}>
              <DashboardLayout>
                <AuditTrail />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/transcript-report"
          element={
            <ProtectRoute userRoles={["Admin"]}>
              <DashboardLayout>
                <TranscriptReport />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/transcript-report-details"
          element={
            <ProtectRoute userRoles={["Admin"]}>
              <DashboardLayout>
                <TranscriptReportDetails />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/transcript-admin-users"
          element={
            <ProtectRoute userRoles={["Admin"]}>
              <DashboardLayout>
                <AdminUsers />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/transcript-admin-details"
          element={
            <ProtectRoute userRoles={["Admin"]}>
              <DashboardLayout>
                <TranscriptAdminDetails />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/generate-certificate"
          element={
            <ProtectRoute userRoles={["Admin"]}>
              <DashboardLayout>
                <PendingCertificate />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/pending-certificate"
          element={
            <ProtectRoute userRoles={["Admin"]}>
              <DashboardLayout>
                <PendingCertificate />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
        <Route
          path="/processed-certificate"
          element={
            <ProtectRoute userRoles={["Admin"]}>
              <DashboardLayout>
                <ProcessedCertificate />
              </DashboardLayout>
            </ProtectRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
